import React from 'react';
import styles from '../styles/BooleanAnswerButtons.module.css';
import { useUiCopy } from '../i18n/useUiCopy';

interface BooleanAnswerButtonsProps {
  onAnswer: (answer: boolean) => void;
  disabled?: boolean;
}

const BooleanAnswerButtons: React.FC<BooleanAnswerButtonsProps> = ({ onAnswer, disabled }) => {
  const copy = useUiCopy();
  const handleYes = () => {
    onAnswer(true);
  };

  const handleNo = () => {
    onAnswer(false);
  };

  return (
    <div className={styles.container}>
      <button
        className={styles.button}
        onClick={handleYes}
        disabled={disabled}
      >
        {copy.yes}
      </button>
      <button
        className={styles.button}
        onClick={handleNo}
        disabled={disabled}
      >
        {copy.no}
      </button>
    </div>
  );
};

export default BooleanAnswerButtons;
